import React from 'react';

const VisibleEye: React.FC = () => {
  return (
    <svg
      height="32px"
      width="32px"
      viewBox="0 0 32 32"
      style={{
        fill: 'var(--primary-blue)',
      }}
    >
      <path d="M16 9c4.183 0 7.98 1.803 11.328 5.326.885.931.896 2.369.03 3.316l-.033.035-.096.1C23.906 21.232 20.141 23 16 23c-4.183 0-7.98-1.803-11.328-5.326-.885-.931-.896-2.369-.03-3.316l.033-.035.096-.1C8.094 10.768 11.859 9 16 9zm0 1.474c-3.667 0-7.015 1.555-10.044 4.665l-.091.095-.093.096-.023.026c-.335.378-.327.945.023 1.314C8.85 19.907 12.26 21.526 16 21.526c3.667 0 7.015-1.555 10.044-4.665l.091-.095.093-.096.023-.026c.335-.378.327-.945-.023-1.314C23.15 12.093 19.74 10.474 16 10.474zm-.063.86c2.63 0 4.762 2.089 4.762 4.666 0 2.577-2.132 4.667-4.762 4.667-2.63 0-4.761-2.09-4.761-4.667s2.132-4.667 4.761-4.667zm0 1.473c-1.799 0-3.258 1.43-3.258 3.193 0 1.763 1.459 3.193 3.258 3.193 1.8 0 3.258-1.43 3.258-3.193 0-1.763-1.458-3.193-3.258-3.193z" />
    </svg>
  );
};

export default VisibleEye;
